import { SonyPlaystationIcon } from './SonyPlaystationIcon';

/**
 * author: Contributors
 * id FF92F5A9-DE89-4E7D-BCAB-98920EA96FFE
 * name sony-playstation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sony-playstation.svg
 * tags
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const PlaystationNetworkIcon = SonyPlaystationIcon;
export default PlaystationNetworkIcon